module.exports = __webpack_public_path__ + "static/media/v2_mask_4.34325754.png";